export default __webpack_public_path__ + "static/media/queue_qr_phitsanulok_v2.00ff8152.png";